module.exports = "<span class=\"menu-icon\" [ngClass]=\"icon\">&nbsp;</span>\n"